import { c } from '@debbie/cortex/dist/index.js';
import React, { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import { Link } from 'react-router-dom';
import { styled } from 'styled-components';
import THEME from '../theme.js';
import ExternalLink from './Icons/ExternalLink.js';
import Filter from './Icons/Filter.js';
import HelpCircle from './Icons/HelpCircle.js';
import { Input, RadioSelect } from './index.js';
import Panel from './Panel.js';
import PlaceholderLoader from './PlaceholderLoader.js';
const setDefaultNumberOfItems = (defaultNumber) => {
    return defaultNumber ? defaultNumber : 25;
};
const TodoPanel = (props) => {
    const { data } = props;
    const defaultCount = setDefaultNumberOfItems(props.numberOfItemsToShow);
    const lang = useSelector((s) => s.lang);
    const [groupedView, setGroupedView] = useState(props.groupedView || false);
    const [numberOfItemsToShow, setNumberOfItemsToShow] = useState(defaultCount);
    const [tabIndex, setTabIndex] = useState(0);
    const [q, setQ] = useState('');
    const [selectedIndex, setSelectedIndex] = useState(0);
    const [isActive, setIsActive] = useState(false);
    const [groups, setGroups] = useState([]);
    const [list, setList] = useState([]);
    const [nothingToShowText, setNothingToShowText] = useState(null);
    const items = groupedView ? groups[tabIndex] : list[tabIndex];
    const totalItems = data[tabIndex]?.items ? data[tabIndex].items.length : 0;
    const setIndex = (selectedIndex) => {
        setSelectedIndex(selectedIndex < 0
            ? 0
            : selectedIndex >= totalItems
                ? totalItems - 1
                : selectedIndex);
    };
    useEffect(() => {
        const newGroups = [];
        const newList = [];
        data.forEach((tabData) => {
            const group = {};
            const list = [];
            tabData.items.forEach((item) => {
                if (`${item.header} ${item.subheader} ${item.small} ${item.searchIndex}`
                    .toLowerCase()
                    .includes(q.trim().toLowerCase())) {
                    list.push({
                        link: `${tabData.path}${item.id}`,
                        previewImageSrc: item.previewImageSrc,
                        label: item.header,
                        small: item.small,
                        icon: item.icon,
                        knowledgeBaseUrl: item.knowledgeBaseUrl,
                        subheader: item.subheader,
                        key: item.id,
                        onClick: item.onClick,
                    });
                }
                if (item.sortString.toLowerCase().includes(q.trim().toLowerCase())) {
                    const groupItem = group[item.sortString];
                    if (!groupItem) {
                        group[item.sortString] = {
                            link: tabData.path === '/cases/' ? `${tabData.path}${item.id}` : '#',
                            label: item.sortString,
                            icon: item.icon,
                            knowledgeBaseUrl: item.knowledgeBaseUrl,
                            small: 1,
                            key: item.sortString,
                        };
                        return;
                    }
                    if (!groupItem.link.includes(`${item.id}`)) {
                        group[item.sortString] = {
                            ...groupItem,
                            link: tabData.path === '/cases/'
                                ? `${groupItem.link},${item.id}`
                                : groupItem.link,
                            small: groupItem.small + 1,
                        };
                    }
                }
            });
            newList.push(list);
            newGroups.push(Object.values(group).sort((a, b) => b.small - a.small));
        });
        setList(newList);
        setGroups(newGroups);
        setNumberOfItemsToShow(defaultCount);
        setSelectedIndex(0);
    }, [data, q]);
    useEffect(() => {
        const tabData = data[tabIndex];
        tabData.nothingToShowText && setNothingToShowText(tabData.nothingToShowText);
    }, [tabIndex]);
    const onToggle = () => {
        setGroupedView(!groupedView);
        setNumberOfItemsToShow(defaultCount);
    };
    const onScroll = (e) => {
        if (e.target.scrollHeight -
            e.target.getBoundingClientRect().height -
            e.target.scrollTop <
            1500 &&
            numberOfItemsToShow < totalItems) {
            setNumberOfItemsToShow(numberOfItemsToShow + 100);
        }
    };
    return (React.createElement(StyledTodoPanel, { placeholder: !props.loading && nothingToShowText && totalItems === 0
            ? nothingToShowText
            : '', onScroll: onScroll, header: React.createElement("div", { className: props.headingClassName },
            data.length === 1 && data[0].path === '/cases/' ? (React.createElement(Link, { to: data[0].path + data[0].items.map(({ id }) => id).join() },
                props.heading,
                ' ',
                React.createElement(ExternalLink, { style: { margin: '0.2em 0 -0.2em' } }),
                ' ')) : (props.heading),
            !props.hideFilter && (React.createElement("small", null,
                totalItems,
                React.createElement(Filter, { style: { cursor: 'pointer' }, onClick: onToggle })))) },
        props.loading && React.createElement(PlaceholderLoader, null),
        data.length > 1 && (React.createElement(MultipleSelectors, null, data.map((m, i) => {
            const label = `${m.heading} (${m.items.length})`;
            return (React.createElement(MultipleSelector, { onClick: () => setTabIndex(i), key: label },
                React.createElement(RadioSelect, { label: label, active: tabIndex === i })));
        }))),
        props.withSearch && (React.createElement(Input, { placeholder: lang.todoPanel.searchTodos, autofocus: true, value: q, onChange: (e) => setQ(e.target.value), onFocus: () => setIsActive(true), onBlur: () => setIsActive(false), onKeyDown: (e) => {
                switch (e.keyCode) {
                    case 13: {
                        items &&
                            items[selectedIndex].link &&
                            c.redirect.redirect(items[selectedIndex].link);
                        return;
                    }
                    case 38: {
                        setIndex(selectedIndex - 1);
                        return;
                    }
                    case 40: {
                        setIndex(selectedIndex + 1);
                        return;
                    }
                }
            } })),
        groupedView && props.groupTitle && (React.createElement(ListItem, { active: false, onClick: () => { } },
            React.createElement("div", { style: { display: 'flex', justifyContent: 'space-between' } },
                React.createElement("p", null, props.groupTitle.label || ''),
                React.createElement("p", null, props.groupTitle.count || '')))),
        items &&
            items.slice(0, numberOfItemsToShow).map((item, i) => (React.createElement(ListItem, { active: i === selectedIndex && isActive, key: item.key }, item.onClick ? (React.createElement("div", { onClick: item.onClick }, ListItemContent(item))) : (React.createElement(Link, { className: "item", to: item.link }, ListItemContent(item)))))),
        !props.loading && nothingToShowText && items.length === 0 && (React.createElement(H2, null, nothingToShowText))));
};
const ListItemContent = (item) => {
    return (React.createElement("div", null,
        item.previewImageSrc && React.createElement(PreviewImg, { src: item.previewImageSrc }),
        React.createElement("h3", { style: { marginBottom: item.subheader ? undefined : '0px' } },
            item.icon,
            " ",
            item.label,
            ' ',
            item.knowledgeBaseUrl && (React.createElement(Help, { onClick: (e) => {
                    e.preventDefault();
                    if (item.knowledgeBaseUrl) {
                        window.open(item.knowledgeBaseUrl, '_blank');
                    }
                } },
                React.createElement(HelpCircle, null)))),
        React.createElement("small", { style: {
                position: 'absolute',
                top: '5px',
                right: '0',
            } }, item.small),
        React.createElement("p", null, item.subheader)));
};
export default TodoPanel;
const Help = styled.div `
  font-size: 1.2em;
  vertical-align: text-bottom;
  margin: 0 60px -10px 10px;
  float: right;
  color: ${THEME.COLOR_ACCENT};
`;
const ListItem = styled.div `
  position: relative;
  border-bottom: 1px solid ${THEME.BORDER_STRONG};
  border-left: ${(props) => props.active ? `3px solid ${THEME.COLOR_ACCENT}` : 'none'};
  transition: all 0.2s;
  cursor: pointer;

  & > div,
  & > a > div {
    padding: ${(props) => (props.active ? '5px 5px' : '5px 0')};
  }

  & > h3 > small {
    float: right;

    svg {
      transform: translateY(2px);
      margin-left: 8px;
      font-size: 1.2em;
    }
  }

  h3 {
    margin: 0px 0 5px;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    font-size: 0.9em;
  }

  p {
    margin: 0;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    font-size: 0.7em;
  }

  &:last-child {
    border-bottom: none;
  }
`;
const PreviewImg = styled.img `
  height: 33px;
  width: 33px;
  object-fit: cover;
  border-radius: 3px;
  float: left;
  margin-right: 12px;
`;
const H2 = styled.h2 `
  text-align: center;
  margin: 2em 0;
  opacity: 0.5;
`;
const MultipleSelectors = styled.div `
  padding: 0 0 15px 0;
`;
const MultipleSelector = styled.div `
  display: inline-block;
`;
const StyledTodoPanel = styled(Panel) `
  overflow-x: visible;
  position: relative;

  .header small {
    float: right;

    svg {
      transform: translateY(2px);
      margin-left: 8px;
      font-size: 1.2em;
    }
  }

  a {
    color: inherit;
    text-decoration: none;
  }

  code {
    font-size: 0.6em;
    background: ${THEME.FILL};
    border-radius: 3px;
    padding: 3px 7px;
    margin-right: 15px;
    cursor: pointer;

    svg {
      margin: -4px;
      height: 15px;
      width: 23px;
    }
  }

  .body {
    overflow-y: auto;
    -webkit-overflow-scrolling: touch;
    max-height: 400px;

    @media ${THEME.MEDIA_QUERY_MOBILE} {
      max-height: none;
    }
  }
`;
//# sourceMappingURL=TodoPanel.js.map